import classes from "./ActivityEditor.module.css";
import {
    CHOOSE_QUESTION_TYPE_TEXT,
    COMMON_QUESTION_TYPES_TEXT,
    MORE_QUESTION_TYPES_TEXT,
    QUESTION_TYPES
} from "../../utils/constants";
import React, {useRef} from "react";
import {ReactComponent as CHAT_ICON} from "../../images/bubble_chat_purple.svg"
import {useCardDistributor} from "../../hooks/useCardDistributor";
import {setQuestionType} from "../../utils/questionUtils";

export default function ActivityEditorQuestionTypeChooser({draftActivity, setDraftActivity, currQueDisplay, userSettings}) {
    const commonQuestionTypes = [QUESTION_TYPES.MCSS, QUESTION_TYPES.SA, QUESTION_TYPES.TF, QUESTION_TYPES.FITB, QUESTION_TYPES.CI, QUESTION_TYPES.WC];
    const moreQuestionTypes = [QUESTION_TYPES.RK, QUESTION_TYPES.OE, QUESTION_TYPES.IB, QUESTION_TYPES.MH, QUESTION_TYPES.RETRO, QUESTION_TYPES.BS];
    const cardContainerRef = useRef();

    let {maxCardsPerRow} = useCardDistributor(cardContainerRef, 30, 230, 6, 15);

    const chooseQuestionType = (questionType) => {
        const copy = JSON.parse(JSON.stringify(draftActivity));
        const {gradeSchema} = copy;
        copy.questions = setQuestionType({
            questions: copy.questions, questionType, userSettings, curSerialNo: currQueDisplay, gradeSchema
        });
        setDraftActivity(copy);
    }

    return (
        <div className={classes.questionMainContainer} style={{padding: 0, gap: 15}}>
            <div style={{
                width: "100%",
                display: "flex",
                gap: 15,
                alignItems: "center",
                justifyContent: "center",
                marginTop: 15
            }}>
                <span className={classes.plusIconWrapper}><CHAT_ICON/></span>
                <span className={classes.title}>{CHOOSE_QUESTION_TYPE_TEXT}</span>
            </div>

            <div
                ref={cardContainerRef}
                style={{
                    flex: 1, minHeight: 0, width: "100%", padding: "0 30px 30px 30px", overflowY: "auto",
                    display: "flex", flexDirection: "column", gap: 15
                }}
            >
                <div style={{width: "100%"}}>
                    <span className={classes.title}>{COMMON_QUESTION_TYPES_TEXT}</span>
                    <div className={classes.dividerLine}/>
                </div>

                <div
                    className={classes.questionTypeCardContainer}
                    style={{
                        gridTemplateColumns: new Array(maxCardsPerRow).fill("minmax(0, 1fr)").join(" "),
                        marginBottom: 10
                    }}
                >
                    {commonQuestionTypes.map((questionType, index) => {
                        const {
                            image: QuestionTypeImage,
                            description,
                            detail,
                            name,
                            iconGrey: QuestionTypeIcon
                        } = questionType;
                        return (
                            <div
                                tabIndex={0}
                                role={"button"}
                                key={index}
                                className={classes.questionTypeCard}
                                onClick={() => chooseQuestionType(name)}
                            >
                                <div className={classes.questionTypeImageWrapper}>
                                    <QuestionTypeImage/>
                                </div>
                                <div className={classes.questionTypeDescriptionBar}>
                                    <span className={classes.questionTypeIcon}>
                                        <QuestionTypeIcon/>
                                    </span>
                                    <div className={classes.questionTypeDescription}>
                                        <div className={classes.title} style={{fontSize: 12, lineHeight: 1.6,}}>{description}</div>
                                        <div className={classes.description} style={{fontSize: 12, lineHeight: 1.6,}}>{detail}</div>
                                    </div>
                                </div>
                            </div>
                        );
                    })}
                </div>

                <div style={{width: "100%"}}>
                    <span className={classes.title}>{MORE_QUESTION_TYPES_TEXT}</span>
                    <div className={classes.dividerLine}/>
                </div>

                <div
                    className={classes.questionTypeCardContainer}
                    style={{gridTemplateColumns: new Array(maxCardsPerRow).fill("minmax(0, 1fr)").join(" ")}}
                >
                    {moreQuestionTypes.map((questionType, index) => {
                        const {
                            image: MoreQuestionTypeImage,
                            description,
                            detail,
                            name,
                            iconGrey: MoreQuestionTypeIcon
                        } = questionType;
                        return (
                            <div
                                tabIndex={0}
                                role={"button"}
                                key={index}
                                className={classes.questionTypeCard}
                                onClick={() => chooseQuestionType(name)}
                            >
                                <div className={classes.questionTypeImageWrapper}>
                                    <MoreQuestionTypeImage/>
                                </div>
                                <div className={classes.questionTypeDescriptionBar}>
                                    <span className={classes.questionTypeIcon}>
                                        <MoreQuestionTypeIcon/>
                                    </span>
                                    <div className={classes.questionTypeDescription}>
                                        <div className={classes.title} style={{fontSize: 12, lineHeight: 1.6,}}>{description}</div>
                                        <div className={classes.description} style={{fontSize: 12, lineHeight: 1.6,}}>{detail}</div>
                                    </div>
                                </div>
                            </div>
                        );
                    })}
                </div>
            </div>
        </div>
    );
}